import PiwikPro from '@piwikpro/react-piwik-pro';
import { env } from './env';

export default function register() {

    // Analytics
    window.dataLayer = window.dataLayer || [];
    
    if (env.REACT_APP_PIWIK_CONTAINER_ID) {
        PiwikPro.initialize(env.REACT_APP_PIWIK_CONTAINER_ID, env.REACT_APP_PIWIK_CONTAINER_URL);
    }
}